export default __webpack_public_path__ + "static/media/thumb-Marine-Receiver-2.5fae1c0a.png";